<template>
  <puzzle-grid-zoom
    class="numerex-grid-wrapper"
    :rows="rows"
    :columns="columns"
    :cell-size="cellSize"
  >
    <template #default="{ gridStyle, letterStyle }">
      <div class="puzzle puzzle-font-default" :style="gridStyle">
        <div
          v-for="cell in table"
          :key="`${cell.positionx}-${cell.positiony}`"
          class="column answer"
          :data-positionx="cell.positionx"
          :data-positiony="cell.positiony"
          :aria-label="
            $t('numerex.form.grid.cellLabel', {
              row: Number(cell.positiony) + 1,
              col: Number(cell.positionx) + 1,
            })
          "
        >
          <span class="cell-text" :style="letterStyle">
            {{ cell.text != null ? cell.text : '' }}
          </span>
        </div>
      </div>
    </template>
  </puzzle-grid-zoom>
</template>

<script>
import PuzzleGridZoom from '_shared/PuzzleGridZoom.vue';
import { CELL_SIZE } from './NumerexModel';

export default {
  name: 'numerex-grid',
  components: {
    PuzzleGridZoom,
  },
  props: {
    rows: {
      type: Number,
      required: true,
    },
    columns: {
      type: Number,
      required: true,
    },
    table: {
      type: Array,
      required: true,
    },
    cellSize: {
      type: Number,
      default: CELL_SIZE,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/puzzle';

.numerex-grid-wrapper {
  ::v-deep .column.answer {
    font-size: inherit;
    cursor: default;

    &:hover {
      background: transparent;
    }
  }
}

.cell-text {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #000;
  font-weight: bold;
  font-family: inherit;
  line-height: 1;
  user-select: none;
}
</style>
